
import * as ol from 'openlayers';
import { zoomIn , zoomOut} from './mapClass';

const tmapNormal = new ol.layer.Tile({
  source: new ol.source.XYZ({
    url: 'http://t4.tianditu.com/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=8b00225817f9180eefe7661501017e74'
  }),
  zIndex: -10
});


const imageURL = 'http://t0.tianditu.gov.cn/img_w/wmts?' +
'SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles' +
'&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=8b00225817f9180eefe7661501017e74';


const tmapSatellite = new ol.layer.Tile({
  source: new ol.source.XYZ({
    url: imageURL
  }),
  zIndex: -10
});


const tmapAnnotation = new ol.layer.Tile({
  source: new ol.source.XYZ({
    url: 'http://t3.tianditu.com/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=8b00225817f9180eefe7661501017e74'
  }),
  zIndex: -10
});

const gmapNormal = new ol.layer.Tile({
  source: new ol.source.XYZ({
    url: 'http://www.google.cn/maps/vt/pb=!1m4!1m3!1i{z}!2i{x}!3i{y}!2m3!1e0!2sm!3i345013117!3m8!2szh-CN!3scn!5e1105!12m4!1e68!2m2!1sset!2sRoadmap!4e0'
  }),
  zIndex: -10
});

const gmapSatellite = new ol.layer.Tile({
  source: new ol.source.XYZ({
    url: 'http://www.google.cn/maps/vt?lyrs=s@748&gl=cn&x={x}&y={y}&z={z}'
  }),
  zIndex: -10
});

const gmapRoad = new ol.layer.Tile({
  source: new ol.source.XYZ({
    url: 'http://www.google.cn/maps/vt/pb=!1m4!1m3!1i{z}!2i{x}!3i{y}!2m3!1e0!2sm!3i345013117!3m8!2szh-CN!3scn!5e1105!12m4!1e68!2m2!1sset!2sRoadmapSatellite!4e0'
  }),
  zIndex: -10
});


const gaodeNormal = new ol.layer.Tile({
  source: new ol.source.XYZ({
    url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
  }),
  zIndex: -10
});

const tMapLayerArr = [
  [tmapNormal, tmapAnnotation],
  [tmapSatellite],
  [tmapSatellite, tmapAnnotation],
];

const googleMapLayerArr = [
  [gmapNormal],
  [gmapSatellite],
  [gmapSatellite, gmapRoad]
];

const gaodeLayerArr = [
  [gaodeNormal],
];


export const mapLayerArr = [
  tMapLayerArr,
  googleMapLayerArr,
  gaodeLayerArr
];

export class INITMap {

  public drawArr: Array<boolean> = [false, false];
  public mapTypeArr = [false, false];
  public mapType: number;
  public layerType: number;
  public lMap: ol.Map = null;
  public currentArr: Array<any> = [
    false,
    false,
    false
  ];

  public view: ol.View = new ol.View({
    projection: 'EPSG:4326',
    center: [120.17550675, 30.189238500000002],
    zoom: 10,
    minZoom: 1,
    maxZoom: 18
  });

  public mapOptians: any;

  public lastKey = 2;

  constructor(mapType: number = 0, layerType: number  = 2 ) {
    this.mapTypeArr[mapType] = true;
    this.currentArr[layerType] = true;
    this.mapType = mapType;
     this.layerType = layerType;
     this.mapOptians = {
      controls: ol.control.defaults().extend([
        new ol.control.ScaleLine(),
      ]),
      layers: mapLayerArr[this.mapType][this.layerType]
    };
  }

  public removeLayer(): void {
    const layers = this.lMap.getLayers();
    const layersToRemove = [];
    layers.forEach(function (item) {
      if (item.getZIndex() < 0) {
        layersToRemove.push(item);
      }
    });
    for (let i = 0, len = layersToRemove.length; i < len; i++) {
      this.lMap.removeLayer(layersToRemove[i]);
    }
  }

  public setMapType(key: number): void {
    this.mapTypeArr[1 - key] = false;
    this.mapTypeArr[key] = true;
    this.mapType = key;
    this.removeLayer();
    for (const item of mapLayerArr[key][this.lastKey]) {
      this.lMap.addLayer(item);
    }
  }

  public zoomIn(event: Event): void {
    zoomIn(this.lMap);
    event.stopPropagation();
  }

  public zoomOut(event: Event): void {
    zoomOut(this.lMap);
    event.stopPropagation();
  }

  public setMapLayer(key: number, event: Event): void {
    this.currentArr = this.currentArr.map(res => res = false);
    this.currentArr[key] = true;
    this.removeLayer();
    this.lastKey = key;
    for (const item of mapLayerArr[this.mapType][key]) {
      this.lMap.addLayer(item);
    }
    event.stopPropagation();
  }

  public drawSartEvent(): void {
    this.drawArr[0] =  true;
  }

  public drawEndEvent(): void {
    this.drawArr[0] =  false;
  }

  public drawSartEvent1(): void {
    this.drawArr[1] =  true;
  }

  public drawEndEvent1(): void {
    this.drawArr[1] =  false;
  }
}
